import React, { useEffect, useState } from 'react';
import { Banner, BannerBody } from '@qualtrics/ui-react';
import styles from './bad-request-banner.scss';
import {
  hasReportedBadRequest,
  registerBadRequestHandler,
} from '../../Service/bad-request-reporter';

const MESSAGE = 'GW is misconfigured (400), check the network tab';

// Not translated on purpose: shown to developers on b1-prv only.
export default function BadRequestBanner(): React.ReactElement | null {
  const [hasBadRequest, setHasBadRequest] = useState(hasReportedBadRequest());
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => registerBadRequestHandler(() => setHasBadRequest(true)), []);

  if (!hasBadRequest || isDismissed) {
    return null;
  }
  return (
    <div className={styles.wrapper}>
      <Banner
        status="error"
        role="alert"
        data-testid="bad-request-banner"
        onClose={() => setIsDismissed(true)}
      >
        <BannerBody>
          <span className={styles.oneLine}>{MESSAGE}</span>
        </BannerBody>
      </Banner>
    </div>
  );
}
